import axios from 'axios'

/**
 * @function neighbourhoodMusicAuthorsGet Gets all of the music authors from a particular neighbourhood
 * @param {string} jwt - the JWT token of the user (accessed through UserContext)
 * @param {string} neighbourhoodId - the id of the neighbourhood
 * @returns {Promise} Promise object represents
 */

export const neighbourhoodMusicAuthorsGet = (jwt, neighbourhoodId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_ADMIN_URL}/admin/api/neighbourhood/music_authors?neighbourhood=${neighbourhoodId}`,
        {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        }
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err))
  })
}
